import { z } from "zod";

/**
 * Shared socket shapes for the collection-thread reminder steps. Defining them
 * once keeps the `query_stale_collection_threads` output element identical to
 * the `prepare_collection_reminder` input, so the fan-out edge type-checks.
 */
export const collectionReminderThreadSchema = z.object({
  id: z.string().uuid(),
  referenceNumber: z.number().int(),
  /** Rendered human-readable code, e.g. "COL-1024". */
  code: z.string(),
  title: z.string(),
  type: z.string(),
  customerName: z.string().nullable(),
  /** Legacy digest field from the staleness-reminder era; always null now. */
  daysSinceLastActivity: z.number().int().nullable(),
  /** Linked invoice's remaining balance as a serialized money string. */
  dollarsAtRisk: z.string(),
  /**
   * ISO timestamp of the thread's elapsed "Set next step" follow-up — the
   * reason it is in the reminder at all. Optional/nullable so bundles
   * persisted before this field existed still parse.
   */
  followUpDueAt: z.iso.datetime().nullable().optional(),
});

/**
 * One recipient's reminder: the due follow-up threads assigned to them.
 * Unassigned threads are never bundled — a reminder needs an owner. The
 * fan-out also lets each recipient be notified on their own preferred channels.
 */
export const recipientReminderBundleSchema = z.object({
  recipientUserId: z.string().uuid(),
  threadCount: z.number().int().nonnegative(),
  threads: z.array(collectionReminderThreadSchema),
});
